import { array, date, number, object } from "yup";
import dayjs from "dayjs";

import { DiscountTypeEnum } from "@/features/shared";

export const DEFAULT_VALUES = {
  buyer: null,
  seller: null,
  warehouse: null,
  paymentTerm: null,
  transactionDate: dayjs(),
  taxable: false,
  totalIncludesTax: false,
  taxPercentage: 0,
  taxAmount: 0,
  salesOrderProductVariants: [],
  salesOrderLensProducts: [],
  subtotal: 0,
  discount: 0,
  discountInput: 0,
  discountType: DiscountTypeEnum.FIXED_AMOUNT,
  grandTotal: 0,
  note: "",
};

export const VALIDATION_SCHEMA = object().shape({
  buyer: object().required("Harus diisi").nullable(),
  seller: object().required("Harus diisi").nullable(),
  warehouse: object().required("Harus diisi").nullable(),
  paymentTerm: object().required("Harus diisi").nullable(),
  transactionDate: date()
    .required("Harus diisi")
    .typeError("Format tanggal tidak valid"),
  // `discountInput` is the raw user entry: a percent (0-100) when the type is
  // percentage, otherwise a rupiah amount that cannot exceed the subtotal.
  discountInput: number()
    .transform((value, original) =>
      String(original).trim() === "" ? 0 : value
    )
    .min(0, "Diskon tidak boleh kurang dari 0")
    .when("discountType", {
      is: DiscountTypeEnum.PERCENTAGE,
      then: (schema) => schema.max(100, "Diskon persentase maksimal 100%"),
      otherwise: (schema) =>
        schema.test(
          "not-exceed-subtotal",
          "Diskon tidak boleh melebihi subtotal",
          function (value) {
            return (value || 0) <= (this.parent.subtotal || 0);
          }
        ),
    }),
  salesOrderProductVariants: array().min(
    0,
    "Minimal 1 produk harus ditambahkan"
  ),
  salesOrderLensProducts: array().min(0, "Minimal 1 produk harus ditambahkan"),
});
